import script from "./ErrorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorPage.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorPage.vue?vue&type=style&index=0&id=3f43f4bb&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f43f4bb"]])

export default __exports__